import { render, staticRenderFns } from "./yx-growup-preview.vue?vue&type=template&id=6995aa0d&scoped=true&"
import script from "./yx-growup-preview.vue?vue&type=script&lang=js&"
export * from "./yx-growup-preview.vue?vue&type=script&lang=js&"
import style0 from "./yx-growup-preview.vue?vue&type=style&index=0&id=6995aa0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995aa0d",
  null
  
)

export default component.exports